import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'geojson'

export const dataPointDefinition = {
  retracedId: 'geojson',
  name: 'Geojson',
  meta: {},
  fieldTypeId: 'ADDRESS',
  type: 'GLOBAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'object',
        properties: {
          type: {
            type: 'string',
          },
          geometry: {
            type: 'object',
            properties: {
              type: {
                type: 'string',
              },
              coordinates: {
                type: 'array',
                items: {
                  type: 'number',
                },
              },
            },
            required: ['type', 'coordinates'],
          },
        },
        required: ['type', 'geometry'],
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 150,
  sectionId: '1.1',
  impactArea: 'About',
  impactAreaId: 'ABOUT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
